module.exports = __webpack_public_path__ + "static/media/Smoothie Moody.9fe92593.jpg";